<template>
  <div class="quote">
    <b-container class="px-4">
      <h1 class="text-center mt-5 text-white font-6xl">
        Request a Quote
      </h1>
      <p
        class="mt-3 mb-5 mx-auto text-center text-white font-weight-bold"
        style="max-width: 500px"
      >
        Customers outside of US: we do not support purchases under $500 USD
        unless purchased using a credit card at
        <a class="text-white" href="/purchase">nanome.ai/purchase</a>
      </p>
      <!-- <b-col lg="5" class="text-white font-xl px-4">
          <p class="py-3">
            Nanome is changing how we understand, design, and interact with
            science.
          </p>
          <div class="pb-3">
            <b-embed
              type="iframe"
              aspect="16by9"
              src="https://www.youtube.com/embed/jrdpHPAbi48"
              frameborder="0"
              allowfullscreen
            ></b-embed>
          </div>
          <p>Get ready to re-experience science, all over again.</p>
        </b-col> -->
      <QuoteForm class="quote__form-container" />
    </b-container>

    <div class="quote__bg">
      <div class="quote__bg-offset w-100 bg-primary"></div>
      <svg
        width="1811"
        height="1565"
        viewBox="0 0 1811 1565"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-100"
      >
        <path
          d="M-88.9927 0H1810.5C1810.5 0 1810.5 427.409 1547 592C1376.5 698.5 982.616 708.595 715.695 865.095C477.261 1004.89 427.465 1178.25 341.109 1298.82C156.26 1556.75 -90.1143 1565 -90.1143 1565L-88.9927 0Z"
          fill="#29A1FF"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import QuoteForm from "@/components/QuoteForm.vue";

export default {
  components: {
    QuoteForm
  },

  metaInfo: {
    titleTemplate: "Get a Quote - %s"
  }
};
</script>

<style lang="scss">
.quote {
  position: relative;
  overflow: hidden;
  margin: 0 -15px;

  &__form-container {
    max-width: 800px;
    margin: 0 auto;
  }

  &__bg {
    width: 90%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    min-width: 80rem;

    &-offset {
      height: 25rem;

      @include breakpoint(tablet) {
        height: 15rem;
      }

      @include breakpoint(desktop) {
        display: none;
      }
    }
  }
}
</style>
